module.exports = __webpack_public_path__ + "images/165_320.jpg";